import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import servicePeople from 'services/people';

/**
 * @typedef {Object} PaymentEmailChangeMutationVariables
 * @property {string} token - Encrypted payment email change token
 * @property {string} email - New payment email address
 */

/**
 * @typedef {Object} PaymentEmailChangeResponse
 * @property {boolean} success
 * @property {string} payment_email - The updated payment email
 */

/** @typedef {Omit<UseMutationOptions<PaymentEmailChangeResponse, Error, PaymentEmailChangeMutationVariables, unknown>, 'mutationKey' | 'mutationFn'>} UsePaymentEmailChangeMutationOptions */

/**
 * Mutation hook to update a person's payment email via the self-service token flow.
 *
 * @param {UsePaymentEmailChangeMutationOptions} [options={}]
 * @returns {import('@tanstack/react-query').UseMutationResult<PaymentEmailChangeResponse, Error, PaymentEmailChangeMutationVariables, unknown>}
 */
export const usePaymentEmailChangeMutation = (options = {}) =>
    useMutation({
        ...options,
        mutationKey: ['payment-email-change'],
        /** @param {PaymentEmailChangeMutationVariables} variables */
        mutationFn: ({ token, email }) => servicePeople.changePaymentEmail(token, email)
    });
